/**
 * @generated SignedSource<<7681102ac9d15f8209c8c310b550752b>>
 * @relayHash d78468a8f129743eeff8de37612fc509
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-nft/563.0.0-2026-06-09T16:12:08.244Z/NftProfileImportCollectionListTileSubscription

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftProfileImportCollectionListTileSubscription$variables = {
  id: string;
};
export type NftProfileImportCollectionListTileSubscription$data = {
  readonly nftTokenContractImportUpdate: {
    readonly nftTokenContractImport: {
      readonly " $fragmentSpreads": FragmentRefs<"NftProfileImportCollectionListTile_contractImport">;
    } | null;
  } | null;
};
export type NftProfileImportCollectionListTileSubscription = {
  response: NftProfileImportCollectionListTileSubscription$data;
  variables: NftProfileImportCollectionListTileSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "tokenContractId",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NftProfileImportCollectionListTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftTokenContractImportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftTokenContractImportUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImport",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NftProfileImportCollectionListTile_contractImport"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscriptions",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NftProfileImportCollectionListTileSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "NftTokenContractImportSubscriptionPayload",
        "kind": "LinkedField",
        "name": "nftTokenContractImportUpdate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NftTokenContractImport",
            "kind": "LinkedField",
            "name": "nftTokenContractImport",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "collectionName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "importStatus",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "NftTokenContract",
                "kind": "LinkedField",
                "name": "contract",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 4
                  },
                  {
                    "kind": "Literal",
                    "name": "importStatuses",
                    "value": [
                      "NFT_ITEM_IMPORT_STATUS_COMPLETE",
                      "NFT_ITEM_IMPORT_STATUS_PROCESSING",
                      "NFT_ITEM_IMPORT_STATUS_ERROR"
                    ]
                  }
                ],
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NftTokenContractImportCreatedItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NftItem",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "NftDigitalArtMetadataMedia",
                                    "kind": "LinkedField",
                                    "name": "media",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "poster",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "posterFrameUrl",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": "web",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "webUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "NftDigitalArtMetadata",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "items(first:4,importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\",\"NFT_ITEM_IMPORT_STATUS_PROCESSING\",\"NFT_ITEM_IMPORT_STATUS_ERROR\"])"
              },
              {
                "alias": "completeItems",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "importStatuses",
                    "value": [
                      "NFT_ITEM_IMPORT_STATUS_COMPLETE"
                    ]
                  }
                ],
                "concreteType": "NftTokenContractImportCreatedItemsConnection",
                "kind": "LinkedField",
                "name": "items",
                "plural": false,
                "selections": [
                  (v4/*: any*/)
                ],
                "storageKey": "items(importStatuses:[\"NFT_ITEM_IMPORT_STATUS_COMPLETE\"])"
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-nft/563.0.0-2026-06-09T16:12:08.244Z/NftProfileImportCollectionListTileSubscription",
    "metadata": {},
    "name": "NftProfileImportCollectionListTileSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "8380af48c5193710f60493454f92e79d";

export default node;
